/**
 * Production-safe logger utility
 * Sensitive logs ONLY visible to developer email: aimanalishezanbusiness@gmail.com
 * Restricts visibility without breaking functionality
 */

const DEVELOPER_EMAIL = 'aimanalishezanbusiness@gmail.com';

// Store current user email - set by auth context
let currentUserEmail = null;

const logger = {
  // Set the current user email (call this from auth context when user logs in)
  setCurrentUser: (email) => {
    currentUserEmail = email;
  },

  // Check if current user is the developer
  isDeveloper: () => {
    return currentUserEmail === DEVELOPER_EMAIL;
  },

  // Regular log - only for developer
  log: (...args) => {
    if (currentUserEmail === DEVELOPER_EMAIL) {
      console.log('[DEV]', ...args);
    }
  },

  // Warning - only for developer
  warn: (...args) => {
    if (currentUserEmail === DEVELOPER_EMAIL) {
      console.warn('[DEV]', ...args);
    }
  },

  // Error logs - sanitized for non-developers, full for developer
  error: (...args) => {
    if (currentUserEmail === DEVELOPER_EMAIL) {
      console.error('[DEV ERROR]', ...args);
    } else {
      // Sanitize and show generic error for non-developers
      const sanitized = args.map(arg => {
        if (typeof arg === 'string') {
          // Remove emails, IDs, and sensitive patterns
          return arg.replace(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g, '[email]')
                    .replace(/[a-f0-9-]{36}/gi, '[id]');
        }
        if (typeof arg === 'object' && arg !== null) {
          return '[object]';
        }
        return arg;
      });
      console.error('[ERROR]', ...sanitized);
    }
  },

  // Info - only for developer
  info: (...args) => {
    if (currentUserEmail === DEVELOPER_EMAIL) {
      console.info('[DEV]', ...args);
    }
  },

  // Debug - only for developer
  debug: (...args) => {
    if (currentUserEmail === DEVELOPER_EMAIL) {
      console.debug('[DEV DEBUG]', ...args);
    }
  },

  // Sensitive data log - STRICTLY developer only
  sensitive: (...args) => {
    if (currentUserEmail === DEVELOPER_EMAIL) {
      console.log('[DEV SENSITIVE]', ...args);
    }
    // Completely silent for non-developers
  },

  // Security log - STRICTLY developer only
  security: (...args) => {
    if (currentUserEmail === DEVELOPER_EMAIL) {
      console.warn('[DEV SECURITY]', ...args);
    }
    // Completely silent for non-developers
  },

  // Admin log - STRICTLY developer only
  admin: (...args) => {
    if (currentUserEmail === DEVELOPER_EMAIL) {
      console.log('[DEV ADMIN]', ...args);
    }
    // Completely silent for non-developers
  },

  // Backend/API log - STRICTLY developer only
  api: (...args) => {
    if (currentUserEmail === DEVELOPER_EMAIL) {
      console.log('[DEV API]', ...args);
    }
    // Completely silent for non-developers
  },

  // Clear user on logout
  clearUser: () => {
    currentUserEmail = null;
  }
};

export default logger;
